import Decimal from "decimal.js";

export class TextLengthCalculator {
  public static calculateLength(text: string): number {
    if (!text) { return 0; }
    
    let textLength = 0;
    for (let i = 0; i < text.length; i++) {
      const char = text.substring(i, i + 1);
      if (this.isHankaku(char)) {
        textLength += 1;
      } else {
        textLength += 2;
      }
    }
    // 半角で0.5、全角で1を足す処理だと浮動小数点の誤差対策でmathを使わないといけないので、2倍して整数で処理して、最後に割っている
    // ※+=で書かないとtslintでワーニングが出る
    return new Decimal(textLength).div(2).toNumber();
  }

  public static isHankaku(text: string): boolean {
    return !!text
      ? this.checkLength(text, false)
      : true;
  }

  private static checkLength(str: string, isZenkaku: boolean): boolean {
    for (let i = 0; i < str.length; i++) {
      const c = str.charCodeAt(i);
      // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
      // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
      if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
        if (!isZenkaku) { return true; }
      } else {
        if (isZenkaku) { return true; }
      }
    }
    return false;
  }
}
